var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.3585 4.87301C5.3585 3.44567 6.51984 2.28501 7.94717 2.28501C9.37384 2.28501 10.5345 3.44567 10.5345 4.87301C10.5345 6.29967 9.37384 7.46101 7.94717 7.46101V7.93701L7.92784 7.46101C6.5065 7.45567 5.35384 6.29567 5.3585 4.87301ZM7.92584 8.41234H7.94717C9.89917 8.41234 11.4865 6.82501 11.4865 4.87301C11.4865 2.92101 9.89917 1.33301 7.94717 1.33301C5.9945 1.33301 4.4065 2.92101 4.4065 4.87101C4.39984 6.81767 5.97784 8.40634 7.92584 8.41234ZM3.6665 12.1153C3.6665 11.1519 5.1065 10.6639 7.94717 10.6639C10.7872 10.6639 12.2265 11.1566 12.2265 12.1286C12.2265 13.0919 10.7872 13.5799 7.94717 13.5799C5.1065 13.5799 3.6665 13.0873 3.6665 12.1153ZM2.6665 12.1153C2.6665 14.5799 6.64117 14.5799 7.94717 14.5799C10.2132 14.5799 13.2265 14.3259 13.2265 12.1286C13.2265 9.66394 9.25317 9.66394 7.94717 9.66394C5.6805 9.66394 2.6665 9.91794 2.6665 12.1153Z",
    fill: "#115099"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.a33986a1.svg";
export { ForwardRef as ReactComponent };